import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { style: {"width":"100%","margin":"0 auto","background":"#f5f5f5","margin-top":"0.7rem"} }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { style: {"border-radius":"8px","width":"100%","height":"62px","background":"#FFF","margin-bottom":"20px","padding-left":"16px","color":"#333333","font-weight":"400","font-size":"20px","display":"flex","align-items":"center","column-gap":"40px","cursor":"pointer"} }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 0,
  class: "dataStatus"
}
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = { style: {"height":"32px","line-height":"32px","font-size":"14px","font-weight":"700"} }
const _hoisted_10 = { style: {"color":"rgba(0, 0, 0, 0.6)"} }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 0,
  style: {"padding-bottom":"30px","display":"flex","justify-content":"flex-end","align-items":"center","width":"100%"}
}
const _hoisted_13 = {
  key: 1,
  style: {"display":"flex","justify-content":"center","width":"100%"}
}

import { useRouter } from "vue-router";
import { ref, computed } from "vue";
import { ElMessage } from "element-plus";
import { Axios } from "../../assets/js/ls_com_axios.js";

export default /*@__PURE__*/_defineComponent({
  __name: 'ShadowActivity',
  setup(__props) {

document.title = "标识山西-活动";
const list: any = ref([]);
const index = ref(0);
const Loading = ref(false);
const router = useRouter();
const queryParams = ref({
  total: 0,
  pageNum: 1,
  pageSize: 10,
  listType: 1,
});
const btn = (index_: number) => {
  index.value = index_;
  queryParams.value.listType = index_ == 0 ? 1 : 2;
  getList()
}
const getList = function () {
  let params = {
    pageNum: queryParams.value.pageNum,
    pageSize: queryParams.value.pageSize,
    publishStatus: 1,
    listType: queryParams.value.listType,
    orderByColumn: 'sortCode'
  };
  Loading.value = true;
  Axios("get", "/system/activity/list", params, false, function (res) {
    if (res.data.code == 200) {
      list.value = res.data.rows;
      queryParams.value.total = res.data.total;
    } else {
      ElMessage.error(res.data.message || "网络错误，请稍后重试");
    }
    Loading.value = false;
  });
};
const paginationChange = (num: number) => {
  queryParams.value.pageNum = num;
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
  getList()
}
const getTime = function (item: any) {
  if (item.activityType == 4) {
    return item.createTime.split(" ")[0]
  }
  const endTime = new Date(item.stopTime)
  const now = new Date()
  if (endTime.getTime() < now.getTime()) {
    return '已结束'
  } else {
    return item.startTime.replace('00:00:00', '') + '-' + item.stopTime.replace('00:00:00', '')
  }
}
const isOver = function (item: any) {
  const endTime = new Date(item.stopTime)
  const now = new Date()
  if (endTime.getTime() < now.getTime()) {
    return true;
  } else {
    return false;
  }
}
const getDay = function (item: any) {
  const endTime = new Date(item.stopTime)
  const now = new Date()
  return Math.ceil(((endTime.getTime() - now.getTime()) / (1000 * 60 * 60 * 24)));
}
const showInfo = (item: any) => {
  // console.log(item)
  if (item.activityType == 3) {
    router.push({
      path: "/drawList",
      query: { id: item.id }
    });
  } else {
    router.push({
      path: "/ShowActivity",
      query: { id: item.id, activityType: item.activityType }
    });
  }

}
getList()

return (_ctx: any,_cache: any) => {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          style: _normalizeStyle([{ color: index.value == 0 ? '#2978FF' : '#333333' }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (btn(0)))
        }, _cache[4] || (_cache[4] = [
          _createElementVNode("span", null, "活动列表", -1)
        ]), 4),
        _createElementVNode("div", {
          style: _normalizeStyle([{ color: index.value == 1 ? '#2978FF' : '#333333' }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (btn(1)))
        }, _cache[5] || (_cache[5] = [
          _createElementVNode("span", null, "活动公告", -1)
        ]), 4)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
        return (_openBlock(), _createElementBlock("a", {
          class: "container_body",
          onClick: ($event: any) => (showInfo(item)),
          style: _normalizeStyle({ '--background': item.status == 0 || new Date(item.stopTime).getTime() < new Date().getTime() ? '#333434' : '#2b79ff' }),
          key: index
        }, [
          _createElementVNode("img", {
            src: item.showImage
          }, null, 8, _hoisted_5),
          (item.activityType != 4)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(item.status == 0 || new Date(item.stopTime).getTime() < new Date().getTime() ? '往期活动' : '活动进行中'), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(item.title), 1),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(getTime(item)), 1)
              ])
            ]),
            (item.activityType != 4)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _withDirectives(_createVNode(_component_el_alert, {
                    title: `距离截至还有${getDay(item)}天`,
                    type: "warning",
                    style: {"color":"#ff8a43","background":"#ffdfcc","font-weight":"700"},
                    closable: false
                  }, null, 8, ["title"]), [
                    [_vShow, !isOver(item)]
                  ]),
                  _withDirectives(_createVNode(_component_el_alert, {
                    title: "已结束",
                    type: "info",
                    closable: false
                  }, null, 512), [
                    [_vShow, isOver(item)]
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ], 12, _hoisted_4))
      }), 128)),
      (list.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_el_pagination, {
              total: queryParams.value.total,
              page: queryParams.value.pageNum,
              "onUpdate:page": _cache[2] || (_cache[2] = ($event: any) => ((queryParams.value.pageNum) = $event)),
              onCurrentChange: paginationChange,
              limit: queryParams.value.pageSize,
              "onUpdate:limit": _cache[3] || (_cache[3] = ($event: any) => ((queryParams.value.pageSize) = $event))
            }, null, 8, ["total", "page", "limit"])
          ]))
        : _createCommentVNode("", true),
      (!list.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createVNode(_component_el_empty, { description: "暂无数据" })
          ]))
        : _createCommentVNode("", true)
    ])
  ])), [
    [_directive_loading, Loading.value]
  ])
}
}

})